import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { t } from '../../../../services/i18nService';
import similarityCheckFailedSelector from '../../../../selectors/idverification/SimilarityCheckFailedSelector';

import ExitTestButton from '../../ExitTestButton';
import IdVerificationStartButton from './IdVerificationStartButton';

import styles from '../../testOverview.scss';

class PureSimilarityCheckFailed extends React.PureComponent {
    static propTypes = {
        message: PropTypes.string.isRequired,
        tryAgainLabel: PropTypes.string.isRequired,
    };

    render() {
        const { message, tryAgainLabel } = this.props;

        return (
            <div>
                <p>
                    <i className="fa fa-info-circle" aria-hidden />
                    {` ${message}`}
                </p>
                <p>
                    <IdVerificationStartButton label={tryAgainLabel} />
                    <span className={styles.orSeparator}>{t('general.or')}</span>
                    <ExitTestButton showButtonForNonLockdown />
                </p>
            </div>
        );
    }
}

// Unable to bind "this" directly in Selector file, so I'm doing so here.
function mapStateToProps(state) {
    return similarityCheckFailedSelector.mapStateToProps(state);
}

const SimilarityCheckFailed = connect(
    mapStateToProps,
)(PureSimilarityCheckFailed);

export default SimilarityCheckFailed;
